export interface IAssetUse {
  id?: string;
  identifier?: string;
  description?: string;
  providerId?: string;
  providerIdentifier?: string;
}

export const defaultValue: Readonly<IAssetUse> = {};
